import Swiper, { Autoplay, Navigation } from 'swiper';

class HeroResponsiveCarousel {
    constructor(el) {
        this.el = el;
        this.sliderEl = this.el.querySelector('.responsive-carousel-slider');
        this.imagesWrapperEl = this.el.querySelector('.hero-bg-images-container');
        this.init();
    }

    init() {
        this.initImages();
        this.initSlider();
        this.initPauseOnHover();
    }

    initImages() {
        this.images = this.imagesWrapperEl.querySelectorAll('.responsive-carousel-slide-image');
        this.images.forEach((img, index) => {
            img.style.zIndex = `${this.images.length - index}`;
            img.style.opacity = (index === 0) ? "1" : "0";
        });
    }

    updateImageVisibility(activeIndex) {
        for (let img of this.images) {
            img.style.opacity = '0';
            img.style.zIndex = '0';
        }

        let activeImgIndex = 0;
        if(this.swiper && this.swiper.slides && this.swiper.slides[activeIndex]) {
            activeImgIndex = this.swiper.slides[activeIndex].getAttribute('data-id');
        }
        const activeImg = this.images[activeImgIndex];
        activeImg.style.opacity = '1';
        activeImg.style.zIndex = '1';
    }

    setProgress(from, to, transitionProgress) {
        if(!this.swiper) return;
        const fromID = this.swiper.slides[from].getAttribute('data-id');
        const toID = this.swiper.slides[to].getAttribute('data-id');
        const fromImg = this.images[fromID];
        const toImg = this.images[toID];
        fromImg.style.opacity = 1;
        fromImg.style.zIndex = '1';
        toImg.style.opacity = `${transitionProgress}`;
        toImg.style.zIndex = '2';
    }

    initSlider() {
        if (this.el) {
            let previousProgress = 0;
            const self = this;

            function updateArrowColors(slide) {
                const arrowsColor = slide.getAttribute('data-arrows-color');
                const arrowsHoverColor = slide.getAttribute('data-arrows-color-hover');

                const controls = document.querySelector('.swiper-controls');
                if (arrowsColor) {
                    controls.style.setProperty('--swiper-controls-color', arrowsColor);
                } else {
                    controls.style.removeProperty('--swiper-controls-color');
                }

                if (arrowsHoverColor) {
                    controls.style.setProperty('--swiper-controls-hover-color', arrowsHoverColor);
                } else {
                    controls.style.removeProperty('--swiper-controls-hover-color');
                }
            }


            this.swiper = new Swiper(this.sliderEl, {
                modules: [Autoplay, Navigation],
                speed: 1300,
                loop: true,
                watchSlidesProgress: true,
                autoplay: {
                    enabled: true,
                    delay: 4000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev",
                },
                on: {
                    init: function() {
                        updateArrowColors(this.slides[this.activeIndex]);
                        self.updateImageVisibility(this.activeIndex);
                    },
                    setTranslate: function() {
                        let fromSlide;
                        let toSlide;
                        let transitionProgress;
                        this.slides.forEach((slideEl, slideIndex) => {
                            const progress = slideEl.progress;

                            if (
                                (progress > 0 && progress < 1) ||
                                (progress === 0 && this.progress < previousProgress)
                            ) {
                                fromSlide = slideIndex;
                                toSlide = (slideIndex + 1) % this.slides.length; // Loop around if necessary
                                transitionProgress = progress;
                            }

                            if (
                                (progress < 0 && progress > -1) ||
                                (progress === 0 && this.progress > previousProgress)
                            ) {
                                fromSlide = (slideIndex === 0 ? this.slides.length - 1 : slideIndex - 1); // If we're at the first slide, set fromSlide to the last slide
                                toSlide = slideIndex;
                                transitionProgress = 1 + progress;
                            }
                        });

                        previousProgress = this.progress || 0;

                        if (fromSlide !== undefined && toSlide !== undefined) {
                            self.setProgress(fromSlide, toSlide, transitionProgress);
                        }
                    },
                    setTransition: function(swiper, duration) {
                        for (let img of self.images) {
                            img.style.transition = `opacity ${duration}ms`;
                        }
                    },
                    slideChange: function() {
                        updateArrowColors(this.slides[this.activeIndex]);
                    },
                    slideChangeTransitionEnd: function() {
                        self.updateImageVisibility(this.activeIndex);
                    }
                }
            });
        }
    }

    initPauseOnHover() {
        if (!this.swiper) return;
        
        const pauseElements = this.el.querySelectorAll('[data-pause-on-hover]');
        if (!pauseElements.length) return;

        pauseElements.forEach(element => {
            element.addEventListener('mouseenter', () => {
                if (this.swiper.autoplay.running) {
                    this.swiper.autoplay.stop();
                }
            });

            element.addEventListener('mouseleave', () => {
                this.swiper.autoplay.start();
            });
        });
    }
}

export default HeroResponsiveCarousel;
